/**
 * Asset-URL lookup. Each renderer module asks for the URL of its slot via
 * `assetUrl(slotId, fallback)` instead of hard-coding the path. The Workshop
 * can populate `setAssetOverrides(...)` at boot with per-world overrides;
 * any missing slot falls back to the renderer's own default.
 *
 * This is a simple module-level registry. main.ts MUST call
 * `setAssetOverrides` before any renderer instantiates its GLTFLoader — in
 * practice that means right after we've loaded the WorldConfig from the
 * server and before the first `new FooMesh(...)` constructor runs.
 */

const overrides: Record<string, string> = {};

export function setAssetOverrides(o: Record<string, string> | undefined | null): void {
  for (const k in overrides) delete overrides[k];
  if (o) Object.assign(overrides, o);
}

export function setAssetOverride(slot: string, url: string): void {
  overrides[slot] = url;
}

export function assetUrl(slot: string, fallback: string): string {
  return overrides[slot] ?? fallback;
}

export function getAssetOverrides(): Readonly<Record<string, string>> {
  return overrides;
}
